import Indicador from "..";
import AltCEditFields from "./components/AltCEditFields";
import { AltCParamFields } from "./components/AltCParamFields";
import altCReport from "./reports";
import altCReportSummary from "./reports/summary";
import _ from "lodash"

export default class AltC extends Indicador {
    static get fullName() {
        return "Altura de Cobrição";
    }

    static get abbrev() {
        return "Alt. C";
    }

    static get field() {
        return "altc";
    }

    static get legacyApontamentoMap() {
        return {
            dataHora: {
                newField: "date",
                convert: this.parseLegacyDate,
            },

            talhao: "talhao",
            trator: "trator",
            implemento: "implemento",
            frente: "frente",
            turno: "turno",

            tipo: "tipo",
            estacao: "estacao",

            coletas: {
                type: Array,
                newField: "coletas",
                children: {
                    alturaCobricao: "alturaCobricao",
                    conforme: "conforme",
                    observacaoColeta: "observacao",
                    foto: {
                        newField: "image.uid",
                        convert: this.convertLegacyImageUid,
                    },
                    confirmaRelatorio: "confirmaRelatorio",
                    "foto.georeferencia": "georeferencia",
                    georeferencia: "georeferencia",
                },
            },

            conformidadeAmostra: "conformidade",

            observacaoAmostra: "observacao",

            itensColeta: "images",
        };
    }

    static get legacyParamMap() {
        return {
            aCveraoMinimoManual: "manual.intervaloMinVerao",
            aCveraoMaximoManual: "manual.intervaloMaxVerao",
            aCinvernoMinimoManual: "manual.intervaloMinInverno",
            aCinvernoMaximoManual: "manual.intervaloMaxInverno",
            aCmetaManual: "manual.meta",

            aCveraoMinimoMecanizado: "mecanizado.intervaloMinVerao",
            aCveraoMaximoMecanizado: "mecanizado.intervaloMaxVerao",
            aCinvernoMinimoMecanizado: "mecanizado.intervaloMinInverno",
            aCinvernoMaximoMecanizado: "mecanizado.intervaloMaxInverno",
            aCmetaMecanizado: "mecanizado.meta",

            itensACpontosAmostrados: {
                type: Array,
                newField: "items",
                paramMap: {
                    classificacaoACpontosAmostrados: "classificacao",
                    intervalo1ACpontosAmostrados: "intervaloMin",
                    intervalo2ACpontosAmostrados: "intervaloMax",
                    sinalIntervaloMin: "sinalIntervaloMin",
                    sinalIntervaloMax: "sinalIntervaloMax",
                },
            },
        };
    }

    getAverage(visita, field, tipoName, params) { // pdf da visita ou pdf do laudo
        const apontamentos = visita.getApontamentosByIndicador(this, tipoName)

        if (!_.isEmpty(apontamentos)) {
            if (field === "conformidade") {
                let qtdConforme = 0
                let qtdNaoConforme = 0

                apontamentos.forEach(apontamento => {
                    for (const coleta of apontamento.coletas) {
                        if (coleta.conforme === "Sim") {
                            qtdConforme++
                        } else {
                            qtdNaoConforme++
                        }
                    }
                })

                return (qtdConforme * 100) / (qtdConforme + qtdNaoConforme)
            } else if (field === "arrowNaoConforme") {
                let numAcima = 0, numAbaixo = 0
                let sumAcima = 0, sumAbaixo = 0
                let avgAcima = 0, avgAbaixo = 0
                let percentAcima = 0, percentAbaixo = 0
                let numConforme = 0
                let obj

                for (let i = 0; i < apontamentos.length; i++) {
                    if ( // cálculo já foi feito no cadastro do apontamento
                        apontamentos[i].hasOwnProperty('sumAbaixo')
                        && apontamentos[i].hasOwnProperty('sumAcima')
                        && apontamentos[i].hasOwnProperty('qtdAbaixo')
                        && apontamentos[i].hasOwnProperty('qtdAcima')
                    ) {
                        numAcima += apontamentos[i].qtdAcima
                        numAbaixo += apontamentos[i].qtdAbaixo
                        sumAcima += apontamentos[i].sumAcima
                        sumAbaixo += apontamentos[i].sumAbaixo
                        numConforme += apontamentos[i].qtdConforme
                    } else {
                        const f = parseFloat
                        let qtdAcima = 0
                        let qtdAbaixo = 0
                        let sumAlturaCobricaoAcima = 0
                        let sumAlturaCobricaoAbaixo = 0

                        for (let j = 0; j < apontamentos[i].coletas.length; j++) {
                            if (apontamentos[i].coletas[j].conforme === "Não") {
                                const alturaCobricao = f(apontamentos[i].coletas[j].alturaCobricao)
                                if (
                                    (apontamentos[i].estacao === "Inverno" && alturaCobricao < f(params.intervaloMinInverno))
                                    || (apontamentos[i].estacao === "Verão" && alturaCobricao < f(params.intervaloMinVerao))
                                ) {
                                    qtdAbaixo++
                                    sumAlturaCobricaoAbaixo += alturaCobricao
                                } else if (
                                    (apontamentos[i].estacao === "Inverno" && alturaCobricao > f(params.intervaloMaxInverno))
                                    || (apontamentos[i].estacao === "Verão" && alturaCobricao > f(params.intervaloMaxVerao))
                                ) {
                                    qtdAcima++
                                    sumAlturaCobricaoAcima += alturaCobricao
                                }
                            } else if (apontamentos[i].coletas[j].conforme === "Sim") {
                                numConforme++
                            }
                        }

                        if (qtdAcima > 0) {
                            numAcima += qtdAcima
                            sumAcima += sumAlturaCobricaoAcima
                        }
                        if (qtdAbaixo > 0) {
                            numAbaixo += qtdAbaixo
                            sumAbaixo += sumAlturaCobricaoAbaixo
                        }
                    }
                }

                if (numAcima > 0) {
                    percentAcima = (numAcima * 100) / (numConforme + numAcima + numAbaixo)
                    avgAcima = ((sumAcima / numAcima).toFixed(3))
                } else { avgAcima = 0 }

                if (numAbaixo > 0) {
                    percentAbaixo = (numAbaixo * 100) / (numConforme + numAcima + numAbaixo)
                    avgAbaixo = (((sumAbaixo / numAbaixo)).toFixed(3))
                } else { avgAbaixo = 0 }

                obj = {
                    result: "igual",
                    acima: avgAcima,
                    abaixo: avgAbaixo,
                    qtdAcima: numAcima,
                    qtdAbaixo: numAbaixo,
                    sumAcima: sumAcima,
                    sumAbaixo: sumAbaixo,
                    percentAcima: percentAcima,
                    percentAbaixo: percentAbaixo,
                    estacao: apontamentos[0].estacao
                }

                return obj
            }
        }
    }

    static paramFields(tipoIndicadorField = '') {
        return <AltCParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <AltCEditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return altCReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return altCReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }

        let conformeCount = 0;
        const total = apontamento.coletas.length;

        let qtdAcima = 0 // nº de coletas acima da meta
        let sumAcima = 0 // soma das coletas acima da meta

        let qtdAbaixo = 0 // nº de coletas abaixo da meta
        let sumAbaixo = 0 // soma das coletas abaixo da meta

        for (const coleta of apontamento.coletas) {
            if (
                f(coleta.alturaCobricao) >= f(params.intervaloMin) &&
                f(coleta.alturaCobricao) <= f(params.intervaloMax)
            ) {
                coleta.conforme = "Sim";
                coleta.acima = 0
                coleta.abaixo = 0
                conformeCount++;
            } else {
                coleta.conforme = "Não"
                if (f(coleta.alturaCobricao) > f(params.intervaloMax)) { // acima
                    coleta.acima = 1
                    coleta.abaixo = 0
                    qtdAcima++
                    sumAcima = f(sumAcima) + f(coleta.alturaCobricao)
                } else if (f(coleta.alturaCobricao) < f(params.intervaloMin)) { // abaixo
                    coleta.acima = 0
                    coleta.abaixo = 1
                    qtdAbaixo++
                    sumAbaixo = f(sumAbaixo) + f(coleta.alturaCobricao)
                }
            }
        }

        apontamento.qtdAcima = qtdAcima
        if (qtdAcima > 0) { // nao da pra fazer divisao por zero
            apontamento.percentAcima = (qtdAcima * 100) / (conformeCount + qtdAcima + qtdAbaixo)
            apontamento.mediaAcima = f(sumAcima / qtdAcima) // média das coletas acima da meta
            apontamento.sumAcima = f(sumAcima)
        } else { apontamento.mediaAcima = 0 }

        apontamento.qtdAbaixo = qtdAbaixo
        if (qtdAbaixo > 0) { // nao da pra fazer divisao por zero
            apontamento.percentAbaixo = (qtdAbaixo * 100) / (conformeCount + qtdAcima + qtdAbaixo)
            apontamento.mediaAbaixo = f(sumAbaixo / qtdAbaixo) // média das coletas abaixo da meta
            apontamento.sumAbaixo = f(sumAbaixo)
        } else { apontamento.mediaAbaixo = 0 }

        apontamento.qtdConforme = conformeCount

        return ((100 * conformeCount) / total).toFixed(2);
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatus(conformidade, meta, 86.9, 100, 107.14);
    }

    static getParams(cliente, tipo, estacao, TipoClass) {
        const params = cliente.getParams(AltC, tipo, TipoClass)

        if (params) {
            if (estacao === "Inverno") {
                return {
                    intervaloMin: params.intervaloMinInverno,
                    intervaloMax: params.intervaloMaxInverno,
                    meta: params.meta,
                };
            } else if (estacao === "Verão") {
                return {
                    intervaloMin: params.intervaloMinVerao,
                    intervaloMax: params.intervaloMaxVerao,
                    meta: params.meta,
                };
            }
        }
    }

    static calcPontosAmostrados(apontamento, paramItems) {
        const result = [];

        for (const item of paramItems) {
            let count = 0;

            for (const coleta of apontamento.coletas) {
                if (this.calcPontoAmostradoColeta(item, coleta.alturaCobricao)) {
                    count++;
                }
            }

            result.push({
                ...item,
                count: count,
            });
        }

        return result;
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },

            { title: "Talhão", field: "talhao.nome" },

            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },
            {
                title: "Operador", width: 'auto', getValue: (a) => {
                    if (a.operador && a.operador.operador) return a.operador.operador
                    if (typeof a.operador === "string" && a.operador) return a.operador
                    return "-"
                }
            },
            { title: "Implemento", field: "implemento.nomeImplemento", width: 'auto' },

            { title: "Estação", field: "estacao", width: 'auto' },

            {
                title: "Altura Cobrição", width: 'auto', getValue: (a) => {
                    let sum = 0
                    let arr = a.coletas.map(x => {
                        if (x.alturaCobricao) {
                            sum = sum + parseFloat(x.alturaCobricao)
                            return x.alturaCobricao
                        } else {
                            return 0
                        }
                    })

                    if (sum) {
                        return (sum / arr.length).toFixed(2)
                    } else {
                        return '0'
                    }
                }
            },

            {
                title: "Conf.(%)", field: "conformidade", width: 38, getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta))
                }
            },
        ]
    }

    static getResultStr(apontamento) {
        let sum = 0
        let media = 0
        let arr = apontamento.coletas?.map(x => {
            if (x.alturaCobricao) {
                sum = sum + parseFloat(x.alturaCobricao)
                return x.alturaCobricao
            } else {
                return 0
            }
        })

        if (sum) {
            media = (sum / arr.length).toFixed(2)
        } else {
            media = '0'
        }

        return "Estação: " + apontamento.estacao +
            " e Altura Cobrição: " + media
    }
}
